
import APIService from "../../services/api.service";
import { CacheService } from '../../common/services/cache.service';
import APIOptions from "../../models/apiOptions";
import environment from "../../environment/environment";
import SearchResults from "../../models/searchResult";
import { AssetResponse } from "../../models/assetResponse";

const getAssetById = (...args) => {
  const axios = require('axios');

  const url = `${environment.apiUrl}asset/metadata/${args}?hidenulls`;
  const apiOptions: APIOptions = new APIOptions(url, AssetResponse);
  const T = apiOptions.T;

  const apiService = new APIService<typeof T>(axios, new CacheService, apiOptions.url);
  return apiService.getAnyAsync();
}

const deleteAssetById = (...args) => {
  const axios = require('axios');

  const id = args[0];
  const url = `${environment.apiUrl}asset/delete/${id}?SharedNPSAuthToken=4D6694DF-9B24-4037-845C-B456DB3AEDB3`;
  const apiOptions: APIOptions = new APIOptions(url, AssetResponse);
  const T = apiOptions.T;

  const apiService = new APIService<typeof T>(axios, new CacheService, apiOptions.url);
  return apiService.delete(id, url);
}

const postAsset  = (...args) => {
  const axios = require('axios');
  console.log('upload', args);
  const entity = args[1];
  //const url = `${environment.apiUrl}asset/upload?SharedNPSAuthToken=4D6694DF-9B24-4037-845C-B456DB3AEDB3`;
  const url = `${environment.microUrl}uploads/file`;
  const apiOptions: APIOptions = new APIOptions(url, SearchResults);
  const T = apiOptions.T;
  
  const apiService = new APIService<typeof T>(axios, new CacheService, apiOptions.url);
  return apiService.add(entity);
}

const putAssetById = (...args) => {
  const axios = require('axios');

  const id = args[0];
  const entity = args[1];
  const url = `${environment.eticApiUrl}UpdateRecord/${id}`;
  const apiOptions: APIOptions = new APIOptions(url, SearchResults);
  const T = apiOptions.T;

  const apiService = new APIService<typeof T>(axios, new CacheService, apiOptions.url);
  return apiService.update(entity);
}

export {
  getAssetById,
  deleteAssetById,
  putAssetById,
  postAsset
};